module.exports = __webpack_public_path__ + "static/media/os-app.3229a690.png";